import React, { useState, useEffect } from "react";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";

const PreviewUserModal = ({ isPreviewModalOpen, togglePreviewModal, selectedUser }) => {
  const [userDetails, setUserDetails] = useState(null);

  useEffect(() => {
    if (selectedUser?.user_id) {
      console.log('Selected user:', selectedUser);
    } else {
      setUserDetails(null);
    }
  }, [selectedUser]);

  const userImage = selectedUser?.image
    ? selectedUser.image.includes("profile_pics")
      ? `https://api.theonlysale.com/${selectedUser.image.replace(/\\\\/g, "/")}`
      : `https://api.theonlysale.com/uploads/images/${selectedUser.image.split(/[\\/]/).pop()}`
    : "/default-profile.png";

  return (
    <>
      {isPreviewModalOpen && selectedUser && (
        <div className="fixed inset-0 z-50 flex items-center justify-center w-full h-full overflow-y-auto bg-black bg-opacity-50">
          <div className="relative w-full max-w-2xl p-6 max-h-full">
            <div className="relative p-6 bg-white rounded-lg shadow dark:bg-gray-800 sm:p-8">
              <div className="flex justify-between items-center pb-4 mb-4 border-b dark:border-gray-600">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                  Preview User
                </h3>
                <button
                  type="button"
                  onClick={togglePreviewModal}
                  className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
                >
                  <i className="fa fa-times w-5 h-5"></i>
                  <span className="sr-only">Close modal</span>
                </button>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div className="col-span-2 flex items-center space-x-4">
                  <img
                    src={userImage}
                    alt="User profile"
                    className="w-24 h-24 object-cover rounded-full border border-gray-200 dark:border-gray-700"
                  />
                  <div>
                    <h4 className="text-lg font-medium text-gray-900 dark:text-white">
                      {selectedUser?.name || "Name not available"}
                    </h4>
                    <p className="text-gray-700 dark:text-gray-300">{selectedUser?.email || "Email not available"}</p>
                    <p className="text-gray-700 dark:text-gray-300">{selectedUser?.phone_number || "Phone number not available"}</p>
                    <p className="text-gray-700 dark:text-gray-300">Role: {selectedUser?.role || "Role not available"}</p>
                    <p className="text-gray-700 dark:text-gray-300">Account Status: {selectedUser?.account_status || "Account status not available"}</p>
                    <p className="text-gray-700 dark:text-gray-300">Created At: {selectedUser?.created_at || "Creation date not available"}</p>
                    <p className="text-gray-700 dark:text-gray-300">Updated At: {selectedUser?.updated_at || "Update date not available"}</p>
                    <p className="text-gray-700 dark:text-gray-300">Stripe Customer ID: {selectedUser?.stripe_customer_id || "Stripe customer ID not available"}</p>
                    <p className="text-gray-700 dark:text-gray-300">Verified: {selectedUser?.verified ? "Yes" : "No"}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PreviewUserModal;
